import React, { forwardRef } from "react";

export interface ConditionalWrapProps {
  condition: boolean;
  wrap: (children: React.ReactNode) => React.ReactNode;
  children: React.ReactNode;
}

export const ConditionalWrap = forwardRef<unknown, ConditionalWrapProps>(
  (props, ref) => {
    const { condition, wrap, children } = props;

    // Decide which element will be at the top level
    const topLevel = condition ? wrap(children) : children;

    // Forward BOTH the ref and any injected props (e.g., from MUI Tooltip)
    // to the same element. Keep public types minimal and derive unknown props via cast.
    const {
      condition: _c,
      wrap: _w,
      children: _ch,
      ...injected
    } = props as unknown as Record<string, unknown>;

    const withProps = React.isValidElement(topLevel)
      ? React.cloneElement(topLevel as React.ReactElement, {
          ...injected,
          ref: ref as any,
        })
      : topLevel;

    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{withProps}</>;
  }
);
ConditionalWrap.displayName = "ConditionalWrap";
